const header = document.querySelector("[data-header]");
const revealItems = document.querySelectorAll(".reveal");
const sceneImage = document.querySelector("[data-scene-image]");
const sceneKicker = document.querySelector("[data-scene-kicker]");
const sceneTitle = document.querySelector("[data-scene-title]");
const sceneCopy = document.querySelector("[data-scene-copy]");
const tabs = document.querySelectorAll("[data-scene]");
const productGallery = document.querySelector("[data-product-gallery]");
const productImage = document.querySelector("[data-product-image]");
const productImageButtons = document.querySelectorAll("[data-product-src]");
const productGalleryPrevious = document.querySelector("[data-product-gallery-previous]");
const productGalleryNext = document.querySelector("[data-product-gallery-next]");
const productGalleryStatus = document.querySelector("[data-product-gallery-status]");
const colorOptions = document.querySelectorAll("[data-color-name]");
const colorName = document.querySelector("[data-color-name]:not(button)");
const borderGlowCards = document.querySelectorAll("[data-border-glow]");
const creatorVideos = document.querySelectorAll("[data-creator-video]");
const launchForms = document.querySelectorAll("[data-launch-form]");

const scenes = {
  night: {
    image: "assets/listing/night-feed-wide.jpg",
    alt: "A parent preparing milk during a night feed with the Nurture Wise warmer.",
    kicker: "Night feeds",
    title: "Warmth without waking the whole room.",
    copy: "Keep the process quiet, simple, and close by when the house is finally calm."
  },
  road: {
    image: "assets/listing/road-trip-wide.jpg",
    alt: "A baby in a car seat while milk is prepared with the portable warmer.",
    kicker: "Road trips",
    title: "A feeding routine that fits the car seat schedule.",
    copy: "Portable warming helps parents respond when the next stop is still miles away."
  },
  camp: {
    image: "assets/listing/camping-scene-wide.jpg",
    alt: "A family outdoors with the Nurture Wise portable bottle warmer.",
    kicker: "Camping",
    title: "Prepared for the feed that happens outside the plan.",
    copy: "All-day power and rinse-clean handling support long afternoons away from home."
  }
};

function updateHeader() {
  if (!header) {
    return;
  }

  header.classList.toggle("is-scrolled", window.scrollY > 20);
}

function setupMobileMenus(root = document) {
  const menus = root.querySelectorAll("[data-mobile-menu]");

  menus.forEach(menu => {
    if (menu.dataset.nwMobileMenuInitialized === "true") {
      return;
    }

    menu.dataset.nwMobileMenuInitialized = "true";
    menu.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", () => menu.removeAttribute("open"));
    });

    menu.addEventListener("keydown", event => {
      if (event.key !== "Escape") {
        return;
      }

      menu.removeAttribute("open");
      menu.querySelector("summary")?.focus();
    });
  });
}

document.addEventListener("click", event => {
  document.querySelectorAll("[data-mobile-menu][open]").forEach(menu => {
    if (!menu.contains(event.target)) {
      menu.removeAttribute("open");
    }
  });
});

function setupBorderGlow() {
  borderGlowCards.forEach(card => {
    function getCenter() {
      const { width, height } = card.getBoundingClientRect();
      return [width / 2, height / 2];
    }

    function getEdgeProximity(x, y) {
      const [cx, cy] = getCenter();
      const dx = x - cx;
      const dy = y - cy;
      const kx = dx === 0 ? Infinity : cx / Math.abs(dx);
      const ky = dy === 0 ? Infinity : cy / Math.abs(dy);
      return Math.min(Math.max(1 / Math.min(kx, ky), 0), 1);
    }

    function getCursorAngle(x, y) {
      const [cx, cy] = getCenter();
      const dx = x - cx;
      const dy = y - cy;

      if (dx === 0 && dy === 0) {
        return 0;
      }

      let degrees = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
      if (degrees < 0) {
        degrees += 360;
      }
      return degrees;
    }

    card.addEventListener("pointermove", event => {
      const rect = card.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const edge = getEdgeProximity(x, y);
      const angle = getCursorAngle(x, y);

      card.style.setProperty("--edge-proximity", `${(edge * 100).toFixed(3)}`);
      card.style.setProperty("--cursor-angle", `${angle.toFixed(3)}deg`);
    });

    card.addEventListener("pointerleave", () => {
      card.style.setProperty("--edge-proximity", "0");
    });
  });
}

function setupSplitText(root = document) {
  const items = root.querySelectorAll("[data-split-text]");
  if (!items.length) {
    return;
  }

  const splitObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-split-visible");
          splitObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "-160px 0px -120px 0px" }
  );

  items.forEach(item => {
    if (item.dataset.nwSplitInitialized === "true") {
      return;
    }

    item.dataset.nwSplitInitialized = "true";
    const text = item.textContent.trim();
    const tokens = text.split(/(\s+)/);
    let wordIndex = 0;

    item.setAttribute("aria-label", text);
    item.textContent = "";

    tokens.forEach(token => {
      if (!token.trim()) {
        item.appendChild(document.createTextNode(token));
        return;
      }

      const word = document.createElement("span");
      word.className = "split-word";
      word.setAttribute("aria-hidden", "true");
      word.style.setProperty("--split-index", wordIndex);
      word.textContent = token;
      item.appendChild(word);
      wordIndex += 1;
    });

    splitObserver.observe(item);
  });
}

function setupBlurText(root = document) {
  const items = root.querySelectorAll("[data-blur-text]");
  if (!items.length) {
    return;
  }

  const blurObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-blur-visible");
          blurObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.16, rootMargin: "-120px 0px -100px 0px" }
  );

  items.forEach(item => {
    if (item.dataset.nwBlurInitialized === "true") {
      return;
    }

    item.dataset.nwBlurInitialized = "true";
    const lineSource = item.dataset.blurLines;
    const lines = lineSource
      ? lineSource.split("|").map(line => line.trim()).filter(Boolean)
      : [item.textContent.trim()];
    const accessibleText = lines.join(" ");
    let wordIndex = 0;

    item.setAttribute("aria-label", accessibleText);
    item.textContent = "";

    lines.forEach(line => {
      const lineWrap = document.createElement("span");
      lineWrap.className = "blur-line";
      line.split(/\s+/).filter(Boolean).forEach((token, tokenIndex, tokens) => {
        const word = document.createElement("span");
        word.className = "blur-word";
        word.setAttribute("aria-hidden", "true");
        word.style.setProperty("--blur-index", wordIndex);
        word.textContent = token;
        lineWrap.appendChild(word);

        if (tokenIndex < tokens.length - 1) {
          lineWrap.appendChild(document.createTextNode(lineSource ? "\u00A0" : " "));
        }

        wordIndex += 1;
      });
      item.appendChild(lineWrap);
    });

    blurObserver.observe(item);
  });
}

function setupProductFaq(root = document) {
  const items = root.querySelectorAll(".product-faq-list details");
  items.forEach(item => {
    if (item.dataset.nwFaqInitialized === "true") {
      return;
    }

    item.dataset.nwFaqInitialized = "true";
    item.addEventListener("toggle", () => {
      if (!item.open) {
        return;
      }

      items.forEach(other => {
        if (other !== item) {
          other.open = false;
        }
      });
    });
  });
}

function setupCreatorVideos() {
  if (!creatorVideos.length) {
    return;
  }

  const creatorVideoObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const video = entry.target;

        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.45 }
  );

  creatorVideos.forEach(video => {
    video.muted = true;
    video.playsInline = true;
    creatorVideoObserver.observe(video);
  });
}

function setupLaunchForms() {
  launchForms.forEach(form => {
    const message = form.querySelector("[data-launch-message]");

    form.addEventListener("submit", event => {
      event.preventDefault();

      if (message) {
        message.textContent = "Thanks. We'll share availability and bundle updates soon.";
      }

      form.reset();
    });
  });
}

const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.18 }
);

revealItems.forEach(item => observer.observe(item));
window.addEventListener("scroll", updateHeader, { passive: true });
updateHeader();

function setupHeroCarousel(carousel = document.querySelector("[data-hero-carousel]")) {
  if (!carousel || carousel.dataset.nwCarouselInitialized === "true") {
    return;
  }

  const slides = carousel.querySelectorAll("[data-hero-slide]");
  const dots = carousel.querySelectorAll("[data-hero-dot]");
  carousel.dataset.nwCarouselInitialized = "true";

  if (slides.length < 2) {
    slides[0]?.querySelectorAll("video").forEach(video => {
      video.muted = true;
      video.playsInline = true;
      if (window.getComputedStyle(video).display !== "none") {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    return;
  }

  let activeIndex = 0;
  let heroTimer;
  let heroDelay = 5200;
  let lastHeroAdvance = 0;
  const heroVideo = slides[0].querySelector("video");

  function syncHeroDelayWithVideo() {
    if (!heroVideo || !Number.isFinite(heroVideo.duration) || heroVideo.duration <= 0) {
      return;
    }

    heroDelay = Math.max(3000, Math.round(heroVideo.duration * 1000));
  }

  function restartProgress(step) {
    if (!step) {
      return;
    }

    const fill = step.querySelector(".hero-progress-fill");
    if (!fill) {
      return;
    }

    fill.style.animation = "none";
    fill.offsetHeight;
    fill.style.animation = "";
  }

  function setActiveSlide(nextIndex) {
    syncHeroDelayWithVideo();
    activeIndex = (nextIndex + slides.length) % slides.length;
    carousel.style.setProperty("--hero-progress-duration", `${heroDelay}ms`);

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");

      const video = slide.querySelector("video");
      if (!video) {
        return;
      }

      if (isActive) {
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      const isComplete = index < activeIndex;
      dot.classList.toggle("is-active", isActive);
      dot.classList.toggle("is-complete", isComplete);
      dot.setAttribute("aria-current", isActive ? "true" : "false");

      if (isActive) {
        restartProgress(dot);
      }
    });
  }

  function advanceHeroSlide() {
    const now = performance.now();
    if (now - lastHeroAdvance < 450) {
      return;
    }

    lastHeroAdvance = now;
    setActiveSlide(activeIndex + 1);
    if (!window.Shopify?.designMode) {
      restartTimer();
    }
  }

  function restartTimer() {
    window.clearTimeout(heroTimer);

    heroTimer = window.setTimeout(advanceHeroSlide, heroDelay);
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      setActiveSlide(index);
      if (!window.Shopify?.designMode) {
        restartTimer();
      }
    });
  });

  if (heroVideo) {
    heroVideo.addEventListener("loadedmetadata", () => {
      syncHeroDelayWithVideo();
      carousel.style.setProperty("--hero-progress-duration", `${heroDelay}ms`);
      if (!window.Shopify?.designMode) {
        restartTimer();
      }
      restartProgress(dots[activeIndex]);
    });

    heroVideo.addEventListener("ended", () => {
      if (!slides[activeIndex].contains(heroVideo)) {
        return;
      }

      advanceHeroSlide();
    });
  }

  setActiveSlide(0);
  if (!window.Shopify?.designMode) {
    restartTimer();
  }
}

tabs.forEach(tab => {
  tab.addEventListener("click", () => {
    if (!sceneImage || !sceneKicker || !sceneTitle || !sceneCopy) {
      return;
    }

    const next = scenes[tab.dataset.scene];
    if (!next) {
      return;
    }

    tabs.forEach(item => item.classList.toggle("is-active", item === tab));
    sceneImage.style.opacity = "0";
    window.setTimeout(() => {
      sceneImage.src = next.image;
      sceneImage.alt = next.alt;
      sceneKicker.textContent = next.kicker;
      sceneTitle.textContent = next.title;
      sceneCopy.textContent = next.copy;
      sceneImage.style.opacity = "1";
    }, 180);
  });
});

function setupProductGallery() {
  if (!productGallery || !productImage || productImageButtons.length < 2) {
    return;
  }

  const galleryFrame = productGallery.querySelector(".product-gallery-frame");
  const galleryControls = productGallery.querySelector(".product-gallery-controls");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let requestId = 0;
  let pointerStart = null;

  function currentIndex() {
    return Number(productGallery.dataset.productGalleryIndex || 0);
  }

  function selectImage(nextIndex) {
    const normalizedIndex = (nextIndex + productImageButtons.length) % productImageButtons.length;
    const button = productImageButtons[normalizedIndex];

    if (!button || normalizedIndex === currentIndex()) {
      return;
    }

    const nextRequestId = ++requestId;
    const nextImage = new Image();

    const commitImage = () => {
      if (nextRequestId !== requestId) {
        return;
      }

      productImage.classList.add("is-changing");
      window.setTimeout(() => {
        if (nextRequestId !== requestId) {
          return;
        }

        productImage.srcset = button.dataset.productSrcset || "";
        productImage.sizes = button.dataset.productSizes || "";
        productImage.src = button.dataset.productSrc;
        productImage.alt = button.dataset.productAlt;
        if (nextImage.naturalWidth && nextImage.naturalHeight) {
          productImage.width = nextImage.naturalWidth;
          productImage.height = nextImage.naturalHeight;
        }
        productGallery.dataset.productGalleryIndex = String(normalizedIndex);

        productImageButtons.forEach((item, index) => {
          const isActive = index === normalizedIndex;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-current", isActive ? "true" : "false");
        });

        if (galleryControls) {
          button.scrollIntoView({
            behavior: reduceMotion.matches ? "auto" : "smooth",
            block: "nearest",
            inline: "nearest"
          });
        }

        if (productGalleryStatus) {
          productGalleryStatus.textContent = `Image ${normalizedIndex + 1} of ${productImageButtons.length}: ${button.dataset.productAlt}`;
        }

        productImage.classList.remove("is-changing");
      }, 140);
    };

    nextImage.addEventListener("load", commitImage, { once: true });
    nextImage.addEventListener("error", commitImage, { once: true });
    nextImage.srcset = button.dataset.productSrcset || "";
    nextImage.sizes = button.dataset.productSizes || "";
    nextImage.src = button.dataset.productSrc;
  }

  function moveGallery(offset) {
    selectImage(currentIndex() + offset);
  }

  productImageButtons.forEach((button, index) => {
    button.addEventListener("click", () => selectImage(index));
  });

  productGalleryPrevious?.addEventListener("click", () => moveGallery(-1));
  productGalleryNext?.addEventListener("click", () => moveGallery(1));

  galleryFrame?.addEventListener("keydown", event => {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      moveGallery(-1);
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      moveGallery(1);
    } else if (event.key === "Home") {
      event.preventDefault();
      selectImage(0);
    } else if (event.key === "End") {
      event.preventDefault();
      selectImage(productImageButtons.length - 1);
    }
  });

  galleryFrame?.addEventListener("pointerdown", event => {
    if (!event.isPrimary) {
      return;
    }

    pointerStart = { x: event.clientX, y: event.clientY };
  });

  galleryFrame?.addEventListener("pointerup", event => {
    if (!pointerStart || !event.isPrimary) {
      pointerStart = null;
      return;
    }

    const deltaX = event.clientX - pointerStart.x;
    const deltaY = event.clientY - pointerStart.y;
    pointerStart = null;

    if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) {
      return;
    }

    moveGallery(deltaX < 0 ? 1 : -1);
  });

  galleryFrame?.addEventListener("pointercancel", () => {
    pointerStart = null;
  });

  productImage.addEventListener("dragstart", event => event.preventDefault());
}

setupProductGallery();

colorOptions.forEach(option => {
  if (option.tagName !== "BUTTON") {
    return;
  }

  option.addEventListener("click", () => {
    colorOptions.forEach(item => {
      if (item.tagName === "BUTTON") {
        item.classList.toggle("is-selected", item === option);
        item.setAttribute("aria-checked", item === option ? "true" : "false");
      }
    });

    if (colorName) {
      colorName.textContent = option.dataset.colorName;
    }
  });
});

function getSocialVideoAutoplayUrl(value) {
  if (!value) {
    return "";
  }

  try {
    const url = new URL(value, window.location.origin);
    const hostname = url.hostname.toLowerCase().replace(/^www\./, "");
    const pathParts = url.pathname.split("/").filter(Boolean);

    if (hostname === "youtu.be" || hostname.endsWith("youtube.com") || hostname.endsWith("youtube-nocookie.com")) {
      let videoId = url.searchParams.get("v") || "";
      if (!videoId && hostname === "youtu.be") {
        videoId = pathParts[0] || "";
      }
      if (!videoId && ["embed", "shorts", "live"].includes(pathParts[0])) {
        videoId = pathParts[1] || "";
      }
      if (/^[a-zA-Z0-9_-]{6,}$/.test(videoId)) {
        const safeId = encodeURIComponent(videoId);
        return `https://www.youtube-nocookie.com/embed/${safeId}?autoplay=1&mute=1&loop=1&playlist=${safeId}&controls=0&playsinline=1&rel=0`;
      }
    }

    if (hostname.endsWith("vimeo.com")) {
      const videoId = [...pathParts].reverse().find(part => /^\d+$/.test(part));
      if (videoId) {
        return `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1&background=1`;
      }
    }

    if (hostname.endsWith("tiktok.com")) {
      const videoMarker = pathParts.findIndex(part => part === "video");
      const playerMarker = pathParts.findIndex((part, index) => part === "v1" && pathParts[index - 1] === "player");
      const videoId = videoMarker >= 0 ? pathParts[videoMarker + 1] : pathParts[playerMarker + 1];
      if (/^\d+$/.test(videoId || "")) {
        return `https://www.tiktok.com/player/v1/${videoId}?autoplay=1&loop=1&muted=1&controls=0&rel=0&music_info=0&description=0`;
      }
    }
  } catch (error) {
    return "";
  }

  return "";
}

function canAutoplayDeferredVideo() {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const desktop = window.matchMedia("(min-width: 750px)").matches;
  const saveData = Boolean(navigator.connection?.saveData);
  return desktop && !reducedMotion && !saveData;
}

function hydrateDeferredVideo(video) {
  if (!video || video.dataset.nwVideoLoaded === "true") {
    return Boolean(video);
  }

  let sources = [];
  try {
    sources = JSON.parse(video.dataset.nwVideoSources || "[]");
  } catch (error) {
    return false;
  }

  sources.forEach(item => {
    if (!item?.src) {
      return;
    }

    const source = document.createElement("source");
    source.src = item.src;
    if (item.type) {
      source.type = item.type;
    }
    video.appendChild(source);
  });

  if (!video.querySelector("source")) {
    return false;
  }

  video.dataset.nwVideoLoaded = "true";
  video.load();
  return true;
}

function updateDeferredVideoButton(button, isPlaying) {
  if (!button) {
    return;
  }

  if (!button.dataset.playLabel) {
    button.dataset.playLabel = button.getAttribute("aria-label") || "Play video";
    button.dataset.pauseLabel = button.dataset.playLabel.replace(/^Play\b/i, "Pause");
  }

  button.setAttribute("aria-label", isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel);
  const icon = button.querySelector("[data-video-play-icon]");
  if (icon) {
    icon.textContent = isPlaying ? "❚❚" : "▶";
  }
}

function setupStandaloneVideos(root = document) {
  root.querySelectorAll("[data-nw-standalone-media]").forEach(media => {
    if (media.dataset.nwVideoInitialized === "true") {
      return;
    }

    const video = media.querySelector("[data-nw-standalone-video]");
    const button = media.querySelector("[data-nw-standalone-play]");
    if (!video || !button) {
      return;
    }

    media.dataset.nwVideoInitialized = "true";
    const shouldAutoplay = media.dataset.autoplay === "true";
    const showControls = media.dataset.showControls === "true";

    const syncState = () => {
      const isPlaying = !video.paused && !video.ended;
      media.classList.toggle("is-video-playing", isPlaying);
      updateDeferredVideoButton(button, isPlaying);
    };

    const playVideo = () => {
      if (!hydrateDeferredVideo(video)) {
        return;
      }
      video.controls = showControls;
      video.play().catch(() => syncState());
    };

    button.addEventListener("click", () => {
      if (video.paused || video.ended) {
        playVideo();
      } else {
        video.pause();
      }
    });

    video.addEventListener("loadeddata", () => media.classList.add("is-video-ready"));
    video.addEventListener("play", () => {
      media.classList.add("is-video-ready");
      syncState();
    });
    video.addEventListener("pause", syncState);
    video.addEventListener("ended", syncState);

    const viewportObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && shouldAutoplay && canAutoplayDeferredVideo()) {
          video.muted = true;
          playVideo();
        } else if (!entry.isIntersecting) {
          video.pause();
        }
      });
    }, { rootMargin: "300px 0px", threshold: 0.01 });

    viewportObserver.observe(media);
    updateDeferredVideoButton(button, false);
  });
}

function setupBrandStories(track = document.querySelector("[data-brand-track]")) {
  if (!track || track.dataset.nwStoriesInitialized === "true") {
    return;
  }

  track.dataset.nwStoriesInitialized = "true";
  const sourceCards = Array.from(track.children);
  if (!sourceCards.length) {
    return;
  }

  sourceCards.forEach((card, index) => {
    card.dataset.nwStoryIndex = String(index);
  });

  function createLoopClone(card) {
    const clone = card.cloneNode(true);
    clone.classList.remove("is-centered");
    clone.dataset.nwStoryClone = "true";
    clone.removeAttribute("id");
    clone.removeAttribute("data-shopify-editor-block");
    clone.setAttribute("aria-hidden", "true");
    clone.inert = true;
    clone.querySelectorAll("video, source, iframe, [data-brand-play]").forEach(item => item.remove());
    clone.querySelectorAll("[id]").forEach(item => item.removeAttribute("id"));
    return clone;
  }

  const canLoop = sourceCards.length > 1;
  const prependCards = canLoop ? sourceCards.map(createLoopClone) : [];
  const appendCards = canLoop ? sourceCards.map(createLoopClone) : [];
  track.prepend(...prependCards);
  track.append(...appendCards);

  const cards = [...prependCards, ...sourceCards, ...appendCards];
  const videos = Array.from(track.querySelectorAll("video"));
  const externalVideos = Array.from(track.querySelectorAll("[data-brand-external-video]"));
  let centeredCard = null;
  let scrollFrame = null;
  let loopResetTimer = null;
  let isPointerActive = false;
  let isDragging = false;
  let dragStartX = 0;
  let dragStartScroll = 0;
  let isTrackNearViewport = false;

  videos.forEach(video => {
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.pause();
    const card = video.closest(".brand-story-card");
    const button = card?.querySelector("[data-brand-play]");
    video.addEventListener("loadeddata", () => card?.classList.add("is-video-ready"));
    video.addEventListener("play", () => {
      card?.classList.add("is-video-ready");
      updateDeferredVideoButton(button, true);
    });
    video.addEventListener("pause", () => updateDeferredVideoButton(button, false));
    updateDeferredVideoButton(button, false);
  });

  externalVideos.forEach(video => {
    video.src = "about:blank";
    video.classList.remove("is-playing");
  });

  function setCardMediaState(card, isActive) {
    const video = card.querySelector("video");
    const externalVideo = card.querySelector("[data-brand-external-video]");

    if (video) {
      if (!isTrackNearViewport || !isActive) {
        video.pause();
      } else if (canAutoplayDeferredVideo() && hydrateDeferredVideo(video)) {
        video.play().catch(() => {});
      }
    }

    if (!externalVideo) {
      return;
    }

    const autoplaySrc = externalVideo.dataset.autoplaySrc || getSocialVideoAutoplayUrl(externalVideo.dataset.socialVideoUrl);
    if (isTrackNearViewport && isActive && canAutoplayDeferredVideo() && autoplaySrc) {
      if (externalVideo.src !== autoplaySrc) {
        externalVideo.src = autoplaySrc;
      }
      externalVideo.classList.add("is-playing");
    } else {
      if (externalVideo.getAttribute("src") !== "about:blank") {
        externalVideo.src = "about:blank";
      }
      externalVideo.classList.remove("is-playing");
    }

    updateDeferredVideoButton(card.querySelector("[data-brand-play]"), externalVideo.classList.contains("is-playing"));
  }

  function refreshCenteredMedia() {
    cards.forEach(card => setCardMediaState(card, card === centeredCard));
  }

  track.addEventListener("click", event => {
    const button = event.target.closest("[data-brand-play]");
    if (!button || !track.contains(button)) {
      return;
    }

    const card = button.closest(".brand-story-card");
    const video = card?.querySelector("[data-brand-video]");
    const externalVideo = card?.querySelector("[data-brand-external-video]");

    if (video) {
      if (video.paused || video.ended) {
        if (hydrateDeferredVideo(video)) {
          video.play().catch(() => {});
        }
      } else {
        video.pause();
      }
      return;
    }

    if (externalVideo) {
      const isPlaying = externalVideo.classList.contains("is-playing");
      if (isPlaying) {
        externalVideo.src = "about:blank";
        externalVideo.classList.remove("is-playing");
      } else {
        const autoplaySrc = externalVideo.dataset.autoplaySrc || getSocialVideoAutoplayUrl(externalVideo.dataset.socialVideoUrl);
        if (autoplaySrc) {
          externalVideo.src = autoplaySrc;
          externalVideo.classList.add("is-playing");
        }
      }
      updateDeferredVideoButton(button, externalVideo.classList.contains("is-playing"));
    }
  });

  const trackObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      isTrackNearViewport = entry.isIntersecting;
      refreshCenteredMedia();
    });
  }, { rootMargin: "300px 0px", threshold: 0.01 });

  trackObserver.observe(track);

  function scrollToCard(card, behavior = "smooth") {
    const target = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    track.scrollTo({ left: Math.max(0, Math.min(target, maxScroll)), behavior });
  }

  function getNearestCard() {
    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    let nearest = cards[0];
    let nearestDistance = Infinity;

    cards.forEach(card => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(trackCenter - cardCenter);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearest = card;
      }
    });

    return nearest;
  }

  function normalizeLoopPosition() {
    if (!canLoop) {
      return false;
    }

    const cycleWidth = appendCards[0].offsetLeft - sourceCards[0].offsetLeft;
    const nearest = getNearestCard();
    let correction = 0;

    if (prependCards.includes(nearest)) {
      correction = cycleWidth;
    } else if (appendCards.includes(nearest)) {
      correction = -cycleWidth;
    }

    if (correction === 0) {
      return false;
    }

    track.classList.add("is-loop-resetting");
    track.scrollLeft += correction;
    if (isDragging) {
      dragStartScroll += correction;
    }
    return true;
  }

  function finishLoopReset() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        track.classList.remove("is-loop-resetting");
      });
    });
  }

  function scheduleLoopNormalization(delay = 90) {
    window.clearTimeout(loopResetTimer);
    loopResetTimer = window.setTimeout(() => {
      loopResetTimer = null;
      if (isPointerActive || !normalizeLoopPosition()) {
        return;
      }

      updateCenteredCard();
      finishLoopReset();
    }, delay);
  }

  function updateCenteredCard() {
    const nearest = getNearestCard();

    if (nearest === centeredCard) {
      return;
    }

    centeredCard = nearest;
    cards.forEach(card => {
      const isCentered = card === centeredCard;
      card.classList.toggle("is-centered", isCentered);
      setCardMediaState(card, isCentered);
    });
  }

  track.addEventListener("scroll", () => {
    scheduleLoopNormalization();
    if (scrollFrame === null) {
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        updateCenteredCard();
      });
    }
  }, { passive: true });

  track.addEventListener("pointerdown", event => {
    isPointerActive = true;
    if (event.pointerType !== "mouse" || event.button !== 0) {
      return;
    }

    isDragging = true;
    dragStartX = event.clientX;
    dragStartScroll = track.scrollLeft;
    track.classList.add("is-dragging");
    track.setPointerCapture(event.pointerId);
  });

  track.addEventListener("pointermove", event => {
    if (!isDragging) {
      return;
    }

    track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
  });

  track.addEventListener("dragstart", event => event.preventDefault());

  function stopDragging(event) {
    isPointerActive = false;

    if (isDragging) {
      isDragging = false;
      track.classList.remove("is-dragging");
      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
    }

    scheduleLoopNormalization(120);
  }

  track.addEventListener("pointerup", stopDragging);
  track.addEventListener("pointercancel", stopDragging);

  track.addEventListener("keydown", event => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") {
      return;
    }

    event.preventDefault();
    const currentIndex = Math.max(0, cards.indexOf(centeredCard));
    const direction = event.key === "ArrowRight" ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));
    scrollToCard(cards[nextIndex]);
  });

  window.addEventListener("resize", () => {
    if (scrollFrame === null) {
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        track.classList.add("is-loop-resetting");
        const activeIndex = Number(centeredCard?.dataset.nwStoryIndex);
        if (Number.isInteger(activeIndex) && sourceCards[activeIndex]) {
          scrollToCard(sourceCards[activeIndex], "auto");
        }
        normalizeLoopPosition();
        updateCenteredCard();
        finishLoopReset();
      });
    }
  });

  window.setTimeout(() => {
    scrollToCard(cards[Math.floor((cards.length - 1) / 2)], "auto");
    updateCenteredCard();
  }, 120);
}

function setupEditorTabs(root = document) {
  root.querySelectorAll("[data-nw-tabs]").forEach(tabSection => {
    if (tabSection.dataset.nwTabsInitialized === "true") {
      return;
    }

    tabSection.dataset.nwTabsInitialized = "true";
    const buttons = Array.from(tabSection.querySelectorAll("[data-nw-tab]"));
    const panels = Array.from(tabSection.querySelectorAll("[data-nw-tab-panel]"));

    function activateTab(index, moveFocus = false) {
      buttons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === index;
        button.setAttribute("aria-selected", String(isActive));
        button.tabIndex = isActive ? 0 : -1;
        panels[buttonIndex]?.toggleAttribute("hidden", !isActive);
      });

      if (moveFocus) {
        buttons[index]?.focus();
      }
    }

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => activateTab(index));
      button.addEventListener("keydown", event => {
        let nextIndex = index;
        if (event.key === "ArrowRight") {
          nextIndex = (index + 1) % buttons.length;
        } else if (event.key === "ArrowLeft") {
          nextIndex = (index - 1 + buttons.length) % buttons.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = buttons.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(nextIndex, true);
      });
    });
  });
}

function setupBeforeAfter(root = document) {
  root.querySelectorAll("[data-nw-before-after]").forEach(section => {
    if (section.dataset.nwBeforeAfterInitialized === "true") {
      return;
    }

    section.dataset.nwBeforeAfterInitialized = "true";
    const range = section.querySelector("[data-nw-before-after-range]");
    if (!range) {
      return;
    }

    const updatePosition = () => section.style.setProperty("--nw-before-position", `${range.value}%`);
    range.addEventListener("input", updatePosition);
    updatePosition();
  });
}

document.querySelectorAll("[data-hero-carousel]").forEach(setupHeroCarousel);
document.querySelectorAll("[data-brand-track]").forEach(setupBrandStories);
setupStandaloneVideos();
setupEditorTabs();
setupBeforeAfter();
setupBorderGlow();
setupSplitText();
setupBlurText();
setupProductFaq();
setupCreatorVideos();
setupLaunchForms();
setupMobileMenus();

document.addEventListener("shopify:section:load", event => {
  event.target.querySelectorAll(".reveal").forEach(item => observer.observe(item));
  event.target.querySelectorAll("[data-hero-carousel]").forEach(setupHeroCarousel);
  event.target.querySelectorAll("[data-brand-track]").forEach(setupBrandStories);
  setupStandaloneVideos(event.target);
  setupEditorTabs(event.target);
  setupBeforeAfter(event.target);
  setupSplitText(event.target);
  setupBlurText(event.target);
  setupProductFaq(event.target);
  setupMobileMenus(event.target);
});

document.addEventListener("shopify:block:select", event => {
  const panel = event.target.closest("[data-nw-tab-panel]");
  if (!panel) {
    return;
  }

  const panels = Array.from(panel.parentElement.querySelectorAll("[data-nw-tab-panel]"));
  const tabSection = panel.closest("[data-nw-tabs]");
  const buttons = tabSection ? Array.from(tabSection.querySelectorAll("[data-nw-tab]")) : [];
  buttons[panels.indexOf(panel)]?.click();
});
